module.exports = __webpack_public_path__ + "img/106.2.6c99d463.png";